export default "__VITE_ASSET__ClZQSKf4__"